/* eslint-disable prettier/prettier */
import { useState, useEffect, useContext } from 'react';

export const useTeamFilterOptions = () => {
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const filterOptions = [
    {
      key: 'goals',
      name: 'Mål',
    },
    {
      key: 'penaltyGoals',
      name: 'Mål på straff',
    },
    {
      key: 'allCornerGoals',
      name: 'Mål på hörna',
    },
    {
      key: 'freekickGoals',
      name: 'Frisparksmål',
    },
    {
      key: 'subinGoals',
      name: 'Mål gjorda av inhoppare',
    },
    {
      key: 'yellowCards',
      name: 'Gula kort',
    },
    {
      key: 'redCards',
      name: 'Röda kort',
    },
    // {
    //     key: 'averagePossesion',
    //     name: 'Bollinnehav'
    // },
    // {
    //     key: 'totalDistance',
    //     name: 'Löpmeter'
    // },
    {
      key: 'corners',
      name: 'Antal hörnor',
    },
    {
      key: 'shots',
      name: 'Avslut',
    },
    {
      key: 'shotsOnTarget',
      name: 'Avslut på mål',
    },
    {
      key: 'shotsPostOrBar',
      name: 'Avslut i målramen',
    },
    {
      key: 'setPieceGoals',
      name: 'Gjorda mål på fasta situationer',
    },
    {
      key: 'concededGoalsSetPiece',
      name: 'Insläppta mål på fasta situationer',
    },
    {
      key: 'averageAttendees',
      name: 'Publiksnitt',
    },
    {
      key: 'formPerformance',
      name: 'Form',
    },
    {
      key: 'goalsConceded',
      name: 'Insläppta mål',
    },
    // {
    //     key: 'concededCornerGoal',
    //     name: 'Insläppta mål per hörna'
    // }
  ];
  return [filterOptions, loading, error];
};
